import { getPaystackMode } from "./getPlanCodes";

export const buildSubscriptionPaymentRequest = ({
    email,
    planKey,
    callbackUrl,
}) => ({
    email,
    planKey,
    callback_url: callbackUrl,
    mode: getPaystackMode(),
});
